<template lang="pug">
.case-stack-promotion(v-if="caseStackPromotionActions")
  .case-stack-item(
    v-for="(i, index) in caseStackPromotionActions"
    :key="i.id")
    template
      span(v-if="index === caseStackPromotionActions.length - 1")
        | {{ i.min_qty }}+ cases:&nbsp;
        strong(v-if="i.type === PROMOTION_ACTIONS.FIX_RATE_ADJUSTMENT") {{ i.discount_value | cents }}
        strong(v-if="i.type === PROMOTION_ACTIONS.PERCENTAGE_ADJUSTMENT") {{ i.discount_value | percentage }}
        | &nbsp;OI
      span(v-else)
        | {{ i.min_qty }} - {{ caseStackPromotionActions[index + 1].min_qty - 1 }} cases:&nbsp;
        strong(v-if="i.type === PROMOTION_ACTIONS.FIX_RATE_ADJUSTMENT") {{ i.discount_value | cents }}
        strong(v-if="i.type === PROMOTION_ACTIONS.PERCENTAGE_ADJUSTMENT") {{ i.discount_value | percentage }}
        | &nbsp;OI
</template>

<script>
import { sortBy } from 'lodash'
import { PROMOTION_ACTIONS, PROMOTION_ACTIONS_TYPES } from '~/settings'

export default {
  name: 'CaseStackPromotions',

  props: {
    promotion: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  data () {
    return {
      PROMOTION_ACTIONS
    }
  },

  computed: {
    caseStackPromotionActions () {
      const promoActionType = this.promotion?.promo_action_type || this.promotion?.promo_action_type_str
      if (promoActionType !== PROMOTION_ACTIONS_TYPES.STACKED) return null
      return sortBy(this.promotion?.promotion_actions, 'min_qty')
    }
  }
}
</script>
